import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface MissingAthletesTotalCountResponse {
  count: number;
}

interface IUseMissingAthletesTotalCount {
  enabled?: boolean;
  athleteStatuses?: string[];
  packages?: string[];
}

function useMissingAthletesTotalCount({
  enabled = true,
  athleteStatuses,
  packages,
}: IUseMissingAthletesTotalCount = {}): UseQueryResult<AxiosResponse<MissingAthletesTotalCountResponse>> {
  const fetchMissingAthletesTotalCount = async (): Promise<
    AxiosResponse<MissingAthletesTotalCountResponse>
  > => {
    const params: UrlParams = {};

    if (athleteStatuses && athleteStatuses.length > 0) {
      params.athlete_statuses = athleteStatuses.join(',');
    }
    if (packages && packages.length > 0) {
      params.packages = packages.join(',');
    }

    const queryString = encodeUrlParams(params);
    return client.get(`reports/athletes/missing/count${queryString ? `?${queryString}` : ''}`);
  };

  return useQuery(
    ['missing-athletes-total-count', athleteStatuses, packages],
    fetchMissingAthletesTotalCount,
    {
      enabled: enabled,
      staleTime: 86400000, // 1 day
    },
  );
}

export default useMissingAthletesTotalCount;
